import React from "react";
import Image from "next/image";

const VillaFeatures = ({ features }) => {
  return (
    <div className="flex md:flex-row md:gap-0 gap-2 flex-col items-center md:mb-3.5 mb-2">
      <div className="w-full md:w-1/5">
        <span className="text-xl font-medium leading-normal text-themeBlack">
          Villa Özellikleri
        </span>
      </div>
      <div className="w-full md:w-4/5">
        <div className="flex flex-wrap items-center gap-2">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-center md:py-4 py-2.5 md:px-5 px-3 gap-2 rounded-lg border border-[#E7EDF4]"
            >
              <Image
                src="/icons/check.svg"
                width={14}
                height={14}
                alt={feature.label}
                className="object-contain"
              />
              <span className="text-[#757C7F] text-sm font-medium leading-normal">
                {feature.baslik}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VillaFeatures;
